<template>
  <div id="lcly-button-0">
    <a id="lcly-link-0" href="https://brands.locally.com" target="_blank"><span v-html="bp('locallyLink')"></span></a>
  </div>
</template>

<script>
import {Url} from '@/utils/url';

export default {
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    locallyConfig() {
      return {
        company_name: this.options.companyName,
        company_id: this.options.companyId,
        inline: '1',
        lang: this.$store.state.locale.toLowerCase().replace(/_/g, '-'),
        no_link: '1',
      };
    },
    locallyQuery() {
      return Url.objectToQueryStringArray(this.locallyConfig).join('&');
    },
  },
  mounted() {
    this.appendLocallyScript();
  },
  methods: {
    appendLocallyScript() {
      const script = document.createElement('script');
      script.src = `${this.options.baseUrl}/stores/map.js?${this.locallyQuery}`;
      document.head.appendChild(script);
    },
  },
};
</script>
